import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { waitlistAPI } from '../api';

function Waitlist() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    name: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await waitlistAPI.join(formData.email, formData.name, formData.message);
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to join waitlist');
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  if (success) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h2>🎉 You're on the Waitlist!</h2>
          <p style={{ fontSize: '1.1rem', marginBottom: '20px' }}>
            Thank you for joining! We've added you to the waitlist.
          </p>
          <div className="info-message" style={{ marginBottom: '20px' }}>
            <p>
              <strong>What happens next?</strong>
            </p>
            <ul style={{ textAlign: 'left', marginTop: '10px' }}>
              <li>Our team reviews the waitlist regularly and approves new members as space opens up</li>
              <li>When you're approved, you'll receive an email with a special invitation link to create your account</li>
              <li>If you know someone already running a group, they can still invite you directly and you'll skip the waitlist</li>
            </ul>
          </div>
          <button
            onClick={() => navigate('/')}
            className="btn btn-primary"
            style={{ width: '100%' }}
          >
            Back to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>🎁 Join the Waitlist</h2>

        <p style={{ fontSize: '1rem', marginBottom: '20px', color: '#666' }}>
          WhoIsYourSanta is invitation-only. Join our waitlist and group organizers can invite you to their Secret Santa exchanges!
        </p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Name *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              disabled={loading}
              placeholder="Your name"
            />
          </div>

          <div className="form-group">
            <label>Email *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={loading}
              placeholder="your.email@example.com"
            />
          </div>

          <div className="form-group">
            <label>Message (Optional)</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              disabled={loading}
              placeholder="Tell us why you want to join (optional)"
              rows="4"
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '1rem',
                fontFamily: 'inherit',
                resize: 'vertical'
              }}
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
            style={{ width: '100%' }}
          >
            {loading ? 'Joining...' : 'Join Waitlist'}
          </button>
        </form>

        <div className="auth-toggle" style={{ marginTop: '20px' }}>
          Already have an account?{' '}
          <button onClick={() => navigate('/login')}>
            Login
          </button>
        </div>

        <div className="auth-toggle">
          <button onClick={() => navigate('/')}>
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}

export default Waitlist;
